import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-area-ordenes',
  templateUrl: './area-ordenes.component.html',
  styles: []
})
export class AreaOrdenesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
